import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_mto_item_hdr_RowClass} from '../../../dbschema';

export class MTOItemHdrContainerModel extends BaseContainerModel {

  bl_fi_mto_item_hdr: bl_fi_mto_item_hdr_RowClass = new bl_fi_mto_item_hdr_RowClass();
}
